import { inject, Observer } from "mobx-react"
import withRouter, { WithRouterProps } from "next/dist/client/with-router"
import Head from "next/head"
import * as React from "react"
import styled, { css } from "styled-components"

import Button from "~/components/atoms/Button"
import FunctionLink from "~/components/atoms/FunctionLink"
import Icon from "~/components/atoms/Icon"
import Logo from "~/components/atoms/Logo"
import Pc from "~/components/atoms/Pc"
import Sp from "~/components/atoms/Sp"
import Typography from "~/components/atoms/Typography"
import { ContainerLarge } from "~/components/layouts/Container"
import Header from "~/components/organisms/Header"
import {
  Color,
  IsMobile,
  IsPC,
  LineHeight,
  RadiusSize,
  Shadow,
  SpacingSize,
  TextSize,
  Transition,
  Z,
} from "~/consts/style-mixins"
import { staticPath } from "~/services/helper"

interface State {
  googleFormload: number
}

@inject("uiStore", "userStore")
class ShortInternshipCorpContact extends React.Component<WithRouterProps & StyledProps, State> {
  state = {
    googleFormload: 0,
  }

  componentDidMount() {
    const googleForm = document.getElementById("google-form")

    if (googleForm) {
      googleForm.onload = () => {
        this.setState({ googleFormload: this.state.googleFormload + 1 })
        // Googleフォーム送信時にgoogleForm.onloadが再度実行される -> googleFormload > 1であればフォーム送信完了と判定
        if (this.state.googleFormload > 1) {
          location.href = "/next/short-internships/corp-contact?submit=complete#form"
        }
      }
    }
  }

  render() {
    const { router } = this.props

    return (
      <>
        <Head>
          <title>インターンシップ・サマーインターンの採用はInfra（インフラ）</title>
          <meta
            name="description"
            content="早期から企業で働く経験を積むなどキャリア活動をする意欲の高い人材の母集団形成を。短期インターン・サマーインターン求人掲載サイトInfra。"
          />
          <meta property="og:title" content="インターンシップ・サマーインターンの採用はInfra（インフラ）" />
          <meta
            property="og:description"
            content="早期から企業で働く経験を積むなどキャリア活動をする意欲の高い人材の母集団形成を。短期インターン・サマーインターン求人掲載サイトInfra。"
          />
          <meta
            property="og:image"
            content={`${process.env.APP_HOST + staticPath("/static/images/short-internship/corp-contact/ogp.png")}`}
          />
          <meta name="viewport" content="initial-scale=1,viewport-fit-cover" />
        </Head>
        <Pc>
          <PcHeader onClick={() => (window.location.href = "#form")} />
        </Pc>
        <Sp>
          <Header logoType="ShortIntern" />
          <FixBottom />
        </Sp>
        <Observer>
          {() => (
            <Container>
              <Section>
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-square-1.png")}`}
                  className="decoration d1"
                />
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-line-l.png")}`}
                  className="decoration-line ll l1"
                />
                <MainVisual onClick={() => (window.location.href = "#form")} />
              </Section>
              <Section>
                <Overview />
              </Section>
              <Section>
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-square-2.png")}`}
                  className="decoration d2"
                />
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-line-l.png")}`}
                  className="decoration-line ll l2"
                />
                <Feature />
              </Section>

              <Section>
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-line-s.png")}`}
                  className="decoration-line ls l3"
                />
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-line-l.png")}`}
                  className="decoration-line ll l4"
                />
                <Data />
              </Section>
              <Section>
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-square-1.png")}`}
                  className="decoration d3"
                />
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-square-3.png")}`}
                  className="decoration d4"
                />
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-line-s.png")}`}
                  className="decoration-line ls l5"
                />
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-line-l.png")}`}
                  className="decoration-line ll l6"
                />
                <Sample onClick={() => (window.location.href = "#form")} />
              </Section>
              <Section>
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-square-4.png")}`}
                  className="decoration d5"
                />
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-square-outline-1.png")}`}
                  className="decoration d6"
                />
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-line-l.png")}`}
                  className="decoration-line ll l7"
                />
                <Performance />
              </Section>
              <Section>
                <CvAppeal onClick={() => (window.location.href = "#form")} />
              </Section>
              <Section>
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-square-1.png")}`}
                  className="decoration d8"
                />
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-square-5.png")}`}
                  className="decoration d9"
                />
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-line-l.png")}`}
                  className="decoration-line ll l10"
                />
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-line-l.png")}`}
                  className="decoration-line ll l11"
                />
                <Service />
              </Section>
              <Section>
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-square-outline-1.png")}`}
                  className="decoration d10"
                />
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-square-1.png")}`}
                  className="decoration d11"
                />
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-line-s.png")}`}
                  className="decoration-line ls l12"
                />
                <Company />
              </Section>
              <Section>
                <CvAppeal onClick={() => (window.location.href = "#form")} />
              </Section>
              {/* <Section>
                <img
                  src={`${staticPath(
                    "/static/images/short-internship/corp-contact/decoration-square-outline-3.png"
                  )}`}
                  className="decoration d12"
                />
                <Plan onClick={() => (window.location.href = "#form")} />
              </Section> */}
              <Section>
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-line-l.png")}`}
                  className="decoration-line ll l13"
                />
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-line-s.png")}`}
                  className="decoration-line ls l14"
                />
                <img
                  src={`${staticPath("/static/images/short-internship/corp-contact/decoration-line-l.png")}`}
                  className="decoration-line ll l15"
                />
                <Form complete={router && router.query.submit === "complete"} />
              </Section>
              <Dialog open={false} onClick={() => alert("Dialogを非表示")} />
            </Container>
          )}
        </Observer>
      </>
    )
  }
}

const Container = styled.div`
  position: relative;
  overflow: hidden;
  ${IsPC(css`
    margin-top: 69px;
  `)};
`

const Section = styled.section`
  position: relative;
  .decoration {
    position: absolute;
    z-index: 1;
    &.d1 {
      width: 230px;
      bottom: -88px;
      right: 66px;
      ${IsMobile(css`
        width: 130px;
        bottom: -42px;
        right: -7px;
      `)};
    }
    &.d2 {
      width: 247px;
      bottom: -58px;
      left: 20px;
      ${IsMobile(css`
        width: 140px;
        bottom: -36px;
        left: -20px;
      `)};
    }
    &.d3 {
      width: 266px;
      top: -152px;
      right: -37px;
      ${IsMobile(css`
        width: 107px;
        top: -57px;
        right: -5px;
      `)};
    }
    &.d4 {
      width: 164px;
      top: 40px;
      right: 40px;
      ${IsMobile(css`
        display: none;
      `)};
    }
    &.d5 {
      width: 294px;
      bottom: 35px;
      left: 10px;
      ${IsMobile(css`
        width: 124px;
        bottom: -17px;
        left: 10px;
      `)};
    }
    &.d6 {
      width: 222px;
      bottom: -72px;
      left: -26px;
      ${IsMobile(css`
        width: 88px;
        bottom: -68px;
        right: -5px;
      `)};
    }
    &.d7 {
      width: 273px;
      top: 42px;
      left: 20px;
      ${IsMobile(css`
        display: none;
      `)};
    }
    &.d8 {
      width: 245px;
      top: 520px;
      right: 35px;
      ${IsMobile(css`
        display: none;
      `)};
    }
    &.d9 {
      width: 157px;
      bottom: -113px;
      right: 98px;
      ${IsMobile(css`
        width: 72px;
        bottom: -86px;
        right: 6px;
      `)};
    }
    &.d10 {
      width: 222px;
      top: 549px;
      left: 94px;
      ${IsMobile(css`
        display: none;
      `)};
    }
    &.d11 {
      width: 160px;
      top: 652px;
      left: 22px;
      ${IsMobile(css`
        display: none;
      `)};
    }
    &.d12 {
      width: 150px;
      top: 36px;
      right: 32px;
      ${IsMobile(css`
        width: 75px;
        top: 60px;
        right: 11px;
      `)};
    }
    &.d13 {
      width: 389px;
      top: -40px;
      left: -10px;
      ${IsMobile(css`
        width: 153px;
        top: -50px;
        left: -16px;
      `)};
    }
  }
  .decoration-line {
    position: absolute;
    z-index: 0;
    &.ll {
      width: 375px;
    }
    &.ls {
      width: 144px;
    }
    &.l1 {
      top: 48px;
      right: 50px;
      ${IsMobile(css`
        top: auto;
        bottom: 0px;
        right: -170px;
      `)};
    }
    &.l2 {
      bottom: 108px;
      right: 0px;
      ${IsMobile(css`
        bottom: 500px;
        right: -50px;
      `)};
    }
    &.l3 {
      top: 0px;
      left: -20px;
      ${IsMobile(css`
        top: 0px;
        left: -78px;
      `)};
    }
    &.l4 {
      bottom: 10px;
      right: -76px;
      ${IsMobile(css`
        bottom: 0px;
        right: -272px;
      `)};
    }
    &.l5 {
      bottom: 164px;
      right: 150px;
      ${IsMobile(css`
        top: 500px;
        bottom: auto;
        right: 0px;
      `)};
    }
    &.l6 {
      bottom: 0px;
      left: 150px;
      ${IsMobile(css`
        bottom: 0px;
        left: 20px;
      `)};
    }
    &.l7 {
      top: 138px;
      right: 0px;
      ${IsMobile(css`
        top: 134px;
        right: -100px;
      `)};
    }
    &.l8 {
      bottom: 320px;
      right: 0px;
      ${IsMobile(css`
        bottom: 420px;
        right: -50px;
      `)};
    }
    &.l9 {
      bottom: 146px;
      right: 70px;
      ${IsMobile(css`
        bottom: 290px;
        right: 20px;
      `)};
    }
    &.l10 {
      bottom: 570px;
      left: 33px;
      ${IsMobile(css`
        bottom: 608px;
        left: -180px;
      `)};
    }
    &.l11 {
      bottom: 0px;
      right: -100px;
      ${IsMobile(css`
        bottom: -84px;
        right: -150px;
      `)};
    }
    &.l12 {
      bottom: 116px;
      left: 23px;
      ${IsMobile(css`
        bottom: 10px;
        left: 23px;
      `)};
    }
    &.l13 {
      top: 0x;
      right: 144px;
      ${IsMobile(css`
        top: 43px;
        right: 0px;
      `)};
    }
    &.l14 {
      bottom: 466px;
      right: 100px;
      ${IsMobile(css`
        display: none;
      `)};
    }
    &.l15 {
      bottom: 0px;
      left: 170px;
      ${IsMobile(css`
        bottom: 0px;
        right: 15px;
      `)};
    }
  }
`

// Common
interface HeadingProps {
  subHeading: string
  heading: string
  heading2?: string
  supplement?: string
}

const Heading = ({ subHeading, heading, heading2, supplement }: HeadingProps) => {
  return (
    <HeadingContainer>
      <div className="typo-wrapper">
        <Pc>
          <Typography type="Label" colorProp={Color.Primary} className="caption">
            {subHeading}
          </Typography>
        </Pc>
        <Sp>
          <Typography type="SubLabel" colorProp={Color.Primary} className="caption">
            {subHeading}
          </Typography>
        </Sp>
        <Pc>
          <Typography type="SubHero" colorProp={Color.Black} className="heading">
            {heading}
          </Typography>
          <Typography type="Note" colorProp={Color.Black} className="supplement">
            {supplement}
          </Typography>
        </Pc>
        <Sp>
          <Typography type="Heading" colorProp={Color.Black} className="heading">
            {heading}
          </Typography>
          <Typography type="Heading" colorProp={Color.Black} className="heading">
            {heading2}
          </Typography>
          <Typography type="SubNote" colorProp={Color.Black} className="supplement">
            {supplement}
          </Typography>
        </Sp>
      </div>
    </HeadingContainer>
  )
}

const HeadingContainer = styled.div`
  .typo-wrapper {
    margin-bottom: ${SpacingSize["4XL"]}px;
    text-align: left;
    &:after {
      display: block;
      content: "";
      height: 3px;
      width: 60px;
      background: ${Color.Primary};
      border-radius: 3px;
      margin: ${SpacingSize.M}px auto 0 0;
    }
  }
  .caption {
    margin-bottom: ${SpacingSize.XS}px;
    ${IsMobile(css`
      font-size: 13px;
    `)};
  }
  .heading {
    display: inline-block;
  }
  .supplement {
    color: ${Color.LightGray};
    display: inline-block;
    margin-left: ${SpacingSize.S}px;
    ${IsMobile(css`
      margin-left: 0;
      margin-top: 4px;
    `)};
  }
`

interface CvAppealProps {
  onClick: Function
}
const CvAppeal = ({ onClick }: CvAppealProps) => {
  return (
    <CvAppealContainer>
      <ContainerLarge>
        <Pc>
          <div className="cv-appeal-content">
            <img
              src={staticPath("/static/images/short-internship/corp-contact/cv-appeal-img.png")}
              className="cv-appeal-content_img"
            />
            <div className="cv-appeal-content_inner">
              <Typography type="Heading" className="cv-appeal-content_message">
                少しでも興味をお持ちの方は、
                <br />
                まずはサービス資料請求！
              </Typography>
              <Button size="Medium" onClick={onClick} className="cv-appeal-content_button">
                資料請求・お問い合わせ
              </Button>
            </div>
          </div>
        </Pc>
        <Sp>
          <div className="cv-appeal-content">
            <div className="cv-appeal-content_inner">
              <Typography type="SubHeading" className="cv-appeal-content_message">
                少しでも興味をお持ちの方は、
                <br />
                まずはサービス資料請求！
              </Typography>
              <Button size="Medium" onClick={onClick} className="cv-appeal-content_button">
                資料請求・お問い合わせ
              </Button>
            </div>
          </div>
        </Sp>
      </ContainerLarge>
    </CvAppealContainer>
  )
}

const CvAppealContainer = styled.div`
  position: relative;
  margin: -92px 0;
  max-height: 184px;
  z-index: 1;
  ${IsMobile(css`
    margin: -83px -16px;
    height: 166px;
  `)};
  .cv-appeal-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-image: url(${staticPath("/static/images/short-internship/corp-contact/cv-appeal-bg.png")});
    background-position: center;
    background-size: cover;
    overflow: hidden;
    ${css`
      ${IsPC(`
        ${Shadow.Deep};
        border-radius: ${RadiusSize.Medium}px;
      `)}
      ${IsMobile(`
        background-image: url(${staticPath("/static/images/short-internship/corp-contact/cv-appeal-bg_sp.png")});
      `)}
    `}
  }
  .cv-appeal-content_img {
    width: 500px;
  }
  .cv-appeal-content_inner {
    text-align: center;
    padding: 0 20px;
    margin: auto;
    ${IsMobile(css`
      width: 100%;
      padding: 32px 12px;
    `)};
  }
  .cv-appeal-content_message {
    color: ${Color.White};
    margin-bottom: ${SpacingSize.M}px;
    text-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  }
  .cv-appeal-content_button {
    max-width: 260px;
    margin: auto;
    background: ${Color.White};
    color: ${Color.Primary};
  }
`

interface PcHeaderProps {
  onClick: Function
}
const PcHeader = ({ onClick }: PcHeaderProps) => {
  return (
    <PcHeaderContainer>
      <ContainerLarge>
        <div className="pc-header-inner">
          <a href="/next/short-internships" className="pc-header-inner_logo-area">
            <Logo type="ShortIntern" height={32} />
          </a>
          <div className="pc-header-inner_right">
            <p className="pc-header-inner_tel">TEL：03-6433-1288</p>
            <Button size="Small" onClick={onClick} className="pc-header-inner_button">
              資料請求・お問い合わせ
            </Button>
          </div>
        </div>
      </ContainerLarge>
    </PcHeaderContainer>
  )
}

const PcHeaderContainer = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  background-color: ${Color.White};
  border-bottom: 1px solid ${Color.BorderGray};
  z-index: ${Z.Header};
  .pc-header-inner {
    padding: ${SpacingSize.M}px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }
  .pc-header-inner_logo-area {
    height: 32px;
  }
  .pc-header-inner_right {
    display: flex;
    align-items: center;
  }
  .pc-header-inner_link {
    font-size: ${TextSize.S}px;
    font-weight: bold;
    color: ${Color.Gray};
    text-decoration: none;
    ${Transition.Hover};
    margin-right: ${SpacingSize.XS}px;
    &:hover {
      color: ${Color.Black};
    }
  }
  .pc-header-inner_tel {
    font-size: ${TextSize.S}px;
    font-weight: bold;
    color: ${Color.Gray};
    margin-right: ${SpacingSize.XS}px;
  }
  .pc-header-inner_button {
    width: 180px;
  }
`

const FixBottom = () => {
  return (
    <FixBottomContainer>
      <div className="fix-bottom-inner">
        <div className="fix-bottom-inner_item">
          <img
            src={staticPath("/static/images/short-internship/corp-contact/fix-bottom-tel.png")}
            className="fix-bottom-inner_item-icon"
          />
          <a href="tel:03-6433-1288" className="fix-bottom-inner_item-tel">
            03-6433-1288
          </a>
        </div>
        <div className="fix-bottom-inner_item">
          <img
            src={staticPath("/static/images/short-internship/corp-contact/fix-bottom-cv.png")}
            className="fix-bottom-inner_item-icon"
          />
          <a href="#form" className="fix-bottom-inner_item-cv">
            お問い合わせ
          </a>
        </div>
      </div>
    </FixBottomContainer>
  )
}

const FixBottomContainer = styled.div`
  position: fixed;
  width: 100%;
  bottom: 0;
  border-bottom: 1px solid ${Color.BorderGray};
  z-index: ${Z.Header};
  ${Shadow.Deep};
  .fix-bottom-inner {
    display: flex;
    padding-bottom: env(safe-area-inset-bottom);
    background: linear-gradient(
      90deg,
      ${Color.White} 0%,
      ${Color.White} 50%,
      ${Color.Primary} 50%,
      ${Color.Primary} 100%
    );
  }
  .fix-bottom-inner_item {
    padding: 18px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    font-size: ${TextSize.M}px;
    font-weight: bold;
  }
  .fix-bottom-inner_item-icon {
    width: 20px;
    margin-right: ${SpacingSize.XS}px;
  }
  .fix-bottom-inner_item-tel {
    color: ${Color.Primary};
  }
  .fix-bottom-inner_item-cv {
    color: ${Color.White};
  }
`

interface MainVisualProps {
  onClick: Function
}
const MainVisual = ({ onClick }: MainVisualProps) => {
  return (
    <MainVisualContainer>
      <div className="inner">
        <Pc>
          <img src={staticPath("/static/images/short-internship/corp-contact/mv-mask.png")} className="mv-mask" />
          <img
            src={staticPath("/static/images/short-internship/corp-contact/mv-subtitle.png")}
            className="mv-subtitle"
          />
        </Pc>
        <Sp>
          <img src={staticPath("/static/images/short-internship/corp-contact/mv-mask_sp.png")} className="mv-mask" />
          <img
            src={staticPath("/static/images/short-internship/corp-contact/mv-subtitle_sp.png")}
            className="mv-subtitle"
          />
        </Sp>
        <ContainerLarge className="container">
          <h1 className="hero">
            インターン採用で
            <br className="pc-hide" />
            キャリア意識の
            <br className="sp-hide" />
            高い
            <br className="pc-hide" />
            学生の母集団形成を
          </h1>
          <p className="supplement">
            大学1, 2年次から将来を見据えて
            <br />
            行動する意欲高い学生と早期接点を作る
          </p>
          <Button size="Medium" onClick={onClick} className="mv-button">
            資料請求・お問い合わせ
          </Button>
        </ContainerLarge>
      </div>
    </MainVisualContainer>
  )
}

const MainVisualContainer = styled.div`
  background: ${Color.White};
  padding-top: ${SpacingSize["4XL"]}px;
  ${IsMobile(css`
    padding-top: 40px;
  `)};
  .inner {
    position: relative;
    display: flex;
    align-items: center;
    background-image: url(${staticPath("/static/images/short-internship/corp-contact/mv-bg.png")});
    background-position: center;
    background-size: cover;
    height: 560px;
    ${css`
      ${IsMobile(`
        height: 500px;
        background-image: url(${staticPath("/static/images/short-internship/corp-contact/mv-bg_sp.png")});
      `)}
    `}
  }
  .mv-mask {
    position: absolute;
    top: 0;
    right: 0;
    height: 560px;
    ${IsMobile(css`
      height: 500px;
      top: 0;
      right: -32px;
    `)};
  }
  .mv-subtitle {
    position: absolute;
    top: 48px;
    right: 80px;
    height: 84px;
    ${IsMobile(css`
      height: 106px;
      top: -16px;
      right: 24px;
    `)};
  }
  .container {
    width: 100%;
  }
  .hero {
    font-size: 44px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    color: ${Color.Black};
    text-shadow: 0px 0px 15px rgba(255, 255, 255, 0.5);
    ${IsMobile(css`
      font-size: 30px;
    `)}
  }
  .supplement {
    margin-top: ${SpacingSize.XS}px;
    font-size: ${TextSize.M}px;
    line-height: ${LineHeight.M}%;
    font-weight: bold;
    text-shadow: 0px 0px 10px rgba(255, 255, 255, 0.6);
    ${IsMobile(css`
      font-size: 13px;
    `)}
  }
  .mv-button {
    max-width: 260px;
    width: 100%;
    margin-top: ${SpacingSize["4XL"]}px;
    ${IsMobile(css`
      margin-top: 40px;
    `)};
  }
  .pc-hide {
    display: none;
    ${IsMobile(css`
      display: inline;
    `)};
  }
  .sp-hide {
    ${IsMobile(css`
      display: none;
    `)};
  }
`

const Overview = () => {
  return (
    <OverviewContainer>
      <ContainerLarge className="section-container">
        <Heading subHeading="大学1, 2年次から行動している！" heading="キャリア意識の高い学生データベースから送客" />
        <OverviewServiceContents>
          <li>
            <img
              className="overview-service_contents-img"
              src={`${staticPath("/static/images/short-internship/corp-contact/overview-infra.png")}`}
            />
            <p className="overview-service_contents-text">
              <span className="attention">長期インターン</span>求人サイトで
              <br />
              集めた学生データベース
            </p>
          </li>
          <li>
            <Pc>
              <img
                className="overview-service_contents-img"
                src={`${staticPath("/static/images/short-internship/corp-contact/overview-sending_pc.png")}`}
              />
            </Pc>
            <Sp>
              <img
                className="overview-service_contents-img sending"
                src={`${staticPath("/static/images/short-internship/corp-contact/overview-sending_sp.png")}`}
              />
            </Sp>
          </li>
          <li>
            <img
              className="overview-service_contents-img"
              src={`${staticPath("/static/images/short-internship/corp-contact/overview-company.png")}`}
            />
            <p className="overview-service_contents-text">
              <span className="attention">短期インターン</span>や<span className="attention">新卒</span>の<br />
              母集団形成をしたい企業
            </p>
          </li>
        </OverviewServiceContents>
      </ContainerLarge>
    </OverviewContainer>
  )
}

const OverviewContainer = styled.div`
  background: ${Color.White};
  padding: 96px 0;
  ${IsMobile(css`
    padding: 80px 0;
  `)}
  .section-container {
    position: relative;
    z-index: 0;
  }
`
const OverviewServiceContents = styled.ul`
  display: flex;
  justify-content: center;
  margin-top: ${SpacingSize["4XL"]}px;
  ${IsMobile(css`
    flex-direction: column;
    align-items: center;
  `)}
  li {
    &:not(:first-child) {
      ${IsPC(css`
        margin-left: 16px;
      `)}
      ${IsMobile(css`
        margin-top: 8px;
      `)}
    }
  }
  .overview-service_contents-img {
    display: block;
    max-width: 315px;
    width: 100%;
    ${IsMobile(css`
      max-width: 240px;
      &.sending {
        max-width: 80px;
      }
    `)}
  }
  .overview-service_contents-text {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    margin-top: ${SpacingSize.XS}px;
    .attention {
      color: ${Color.Primary};
    }
  }
`

const Feature = () => {
  return (
    <FeatureContainer>
      <ContainerLarge className="section-container">
        <Heading subHeading="長期インターン求人サイトを通じて集まる！" heading="Infraに集まる学生の特徴" />
        <ul className="feature-content_group">
          <li className="feature-content_item first">
            <div className="feature-content_item-top">
              <img
                src={staticPath("/static/images/short-internship/corp-contact/feature-point.png")}
                className="feature-content_item-icon"
              />
              <p className="feature-content_item-heading">
                結果から逆算して
                <br />
                <span className="attention">計画</span>できる
              </p>
            </div>
            <Typography type="Note" className="feature-content_item-supplement">
              就活を見据えて長期インターンをするために半数以上の学生が2年生以前から利用しており、早期から逆算して行動する計画力があります。
            </Typography>
          </li>
          <li className="feature-content_item">
            <div className="feature-content_item-top">
              <img
                src={staticPath("/static/images/short-internship/corp-contact/feature-point.png")}
                className="feature-content_item-icon"
              />
              <p className="feature-content_item-heading">
                情報感度が高く
                <br />
                <span className="attention">行動力</span>がある
              </p>
            </div>
            <Typography type="Note" className="feature-content_item-supplement">
              長期インターンの認知や参加者は決して多い訳ではありません。最新の就活情報をキャッチアップし、将来を見据えて行動しています。
            </Typography>
          </li>
          <li className="feature-content_item third">
            <div className="feature-content_item-top">
              <img
                src={staticPath("/static/images/short-internship/corp-contact/feature-point.png")}
                className="feature-content_item-icon"
              />
              <p className="feature-content_item-heading">
                <span className="attention">成長意欲</span>があり、
                <br />
                仕事への興味関心が高い
              </p>
            </div>
            <Typography type="Note" className="feature-content_item-supplement">
              多くの選択肢から実務を行う長期インターンに興味を持っています。仕事関心が高く、会社で活躍・成長したいという意欲があります。
            </Typography>
          </li>
        </ul>
        <div className="feature-content_title">
          <Pc>
            <Typography type="SubHeading" className="feature-content_title-text">
              さらに、内定率10%以下の長期インターンに参加した学生は
            </Typography>
          </Pc>
          <Sp>
            <Typography type="SubHeading" className="feature-content_title-text">
              さらに、内定率10%以下の
              <br />
              長期インターンに参加した学生は
            </Typography>
          </Sp>
        </div>
        <ul className="feature-content_group">
          <li className="feature-content_item first">
            <div className="feature-content_item-top">
              <img
                src={staticPath("/static/images/short-internship/corp-contact/feature-point-light.png")}
                className="feature-content_item-icon"
              />
              <p className="feature-content_item-heading">
                社会経験があるため、
                <br />
                <span className="attention">仕事理解</span>が高い
              </p>
            </div>
            <Typography type="Note" className="feature-content_item-supplement">
              仕事のイメージがついた上で会社を選択しているため、ミスマッチが少なく離職率が低い傾向にあります。
            </Typography>
          </li>
          <li className="feature-content_item">
            <div className="feature-content_item-top">
              <img
                src={staticPath("/static/images/short-internship/corp-contact/feature-point-light.png")}
                className="feature-content_item-icon"
              />
              <p className="feature-content_item-heading">
                やりたいことや
                <br />
                <span className="attention">ビジョン</span>が明確
              </p>
            </div>
            <Typography type="Note" className="feature-content_item-supplement">
              実際の社会人と仕事の中で接しているので、やりたいことや自分のビジョンに向き合う機会が増え、明確になっています。
            </Typography>
          </li>
          <li className="feature-content_item third">
            <div className="feature-content_item-top">
              <img
                src={staticPath("/static/images/short-internship/corp-contact/feature-point-light.png")}
                className="feature-content_item-icon"
              />
              <p className="feature-content_item-heading">
                早期から仕事で
                <br />
                <span className="attention">成果</span>が出やすい
              </p>
            </div>
            <Typography type="Note" className="feature-content_item-supplement">
              社員と同じ仕事を経験し、実務スキルを習得しているため、早期からの仕事の成果を見込めます。
            </Typography>
          </li>
        </ul>
      </ContainerLarge>
    </FeatureContainer>
  )
}

const FeatureContainer = styled.div`
  background: ${Color.BackgroundGray};
  padding: 96px 0;
  ${IsMobile(css`
    padding: 80px 0;
  `)}
  .section-container {
    position: relative;
    z-index: 0;
  }
  .feature-content_group {
    display: flex;
    width: 100%;
    ${IsMobile(css`
      flex-direction: column;
    `)};
  }
  .feature-content_item {
    background: ${Color.White};
    padding: ${SpacingSize.XL}px ${SpacingSize.M}px;
    width: 33.3%;
    &.first {
      margin-right: 1px;
    }
    &.third {
      margin-left: 1px;
    }
    ${IsMobile(css`
      width: 100%;
      padding: 20px;
      &.first {
        margin-right: 0px;
        margin-bottom: 1px;
      }
      &.third {
        margin-left: 0px;
        margin-top: 1px;
      }
    `)};
  }
  .feature-content_item-top {
    display: flex;
    align-items: center;
    margin-bottom: ${SpacingSize.S}px;
  }
  .feature-content_item-icon {
    width: 52px;
    margin-right: ${SpacingSize.M}px;
  }
  .feature-content_item-heading {
    font-size: 18px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    .attention {
      color: ${Color.Primary};
    }
    ${IsMobile(css`
      font-size: 18px;
    `)};
  }
  .feature-content_item-supplement {
    ${IsMobile(css`
      font-size: 13px;
    `)};
  }
  .feature-content_title {
    position: relative;
    background: ${Color.Primary};
    margin-top: ${SpacingSize.L}px;
    border-radius: ${RadiusSize.Medium}px ${RadiusSize.Medium}px 0 0;
    text-align: center;
    padding: ${SpacingSize.XS}px 0;
    &:after {
      position: absolute;
      display: inline-block;
      content: "";
      border-style: solid;
      border-width: 12px 20px 0 20px;
      border-color: ${Color.Primary} ${Color.White} ${Color.White} ${Color.White};
      top: 38px;
      left: calc(50% - 20px);
      ${IsMobile(css`
        top: 54px;
      `)};
    }
  }
  .feature-content_title-text {
    color: ${Color.White};
    ${IsMobile(css`
      font-size: 14px;
    `)};
  }
`

const Data = () => {
  return (
    <DataContainer>
      <ContainerLarge className="section-container">
        <Heading
          subHeading="Infraに集まっている学生の特徴がまるわかり！"
          heading="データで見る登録学生"
          supplement="※2021年4月時点の23卒"
        />
        <ul className="data-content_group first">
          <li className="data-content_item">
            <div className="data-content_item-title">
              <Typography type="SubHeading">22卒の登録者数</Typography>
            </div>
            <div className="data-content_item-content">
              <div className="data-content_item-content-inner item1">
                <img src={staticPath("/static/images/short-internship/corp-contact/data-1.png")} className="img" />
                <p className="num">
                  <span className="small">約</span>10,000
                  <span className="small">名</span>
                </p>
                <Typography type="Label" className="subnum">
                  うち長期インターン経験者1000名
                </Typography>
                <div className="supplement-wrapper">
                  <Typography type="SubNote" className="supplement">
                    長期インターンの内定率は
                    <br />
                    10%程度とハードルが高い
                  </Typography>
                </div>
              </div>
            </div>
          </li>
          <li className="data-content_item">
            <div className="data-content_item-title">
              <Typography type="SubHeading">文理比</Typography>
            </div>
            <div className="data-content_item-content">
              <div className="data-content_item-content-inner item2">
                <img src={staticPath("/static/images/short-internship/corp-contact/data-2.png")} className="img" />
                <Typography type="Label" className="summary">
                  全体の文理比と比べ、やや文系が多め
                </Typography>
              </div>
            </div>
          </li>
          <li className="data-content_item">
            <div className="data-content_item-title">
              <Typography type="SubHeading">学歴</Typography>
            </div>
            <div className="data-content_item-content">
              <div className="data-content_item-content-inner item3">
                <Pc>
                  <img src={staticPath("/static/images/short-internship/corp-contact/data-3.png")} className="img" />
                </Pc>
                <Sp>
                  <img src={staticPath("/static/images/short-internship/corp-contact/data-3_sp.png")} className="img" />
                </Sp>
              </div>
            </div>
          </li>
        </ul>
        <ul className="data-content_group">
          <li className="data-content_item half">
            <div className="data-content_item-title">
              <Typography type="SubHeading">2年生以前から動いている学生</Typography>
            </div>
            <div className="data-content_item-content">
              <div className="data-content_item-content-inner item4">
                <img src={staticPath("/static/images/short-internship/corp-contact/data-4.png")} className="img" />
                <Pc>
                  <Typography type="Label" className="summary">
                    早期から就活を見据えて行動している学生が半分以上！
                  </Typography>
                </Pc>
                <Sp>
                  <Typography type="Label" className="summary">
                    早期から就活を見据えて行動している
                  </Typography>
                  <Typography type="Label" className="summary line-after">
                    学生が半分以上！
                  </Typography>
                </Sp>
              </div>
            </div>
          </li>
          <li className="data-content_item half last">
            <div className="data-content_item-title">
              <Typography type="SubHeading">経験した職種</Typography>
            </div>
            <div className="data-content_item-content">
              <div className="data-content_item-content-inner item5">
                <Pc>
                  <img src={staticPath("/static/images/short-internship/corp-contact/data-5.png")} className="img" />
                </Pc>
                <Sp>
                  <img src={staticPath("/static/images/short-internship/corp-contact/data-5_sp.png")} className="img" />
                </Sp>
                <Typography type="Label" className="summary">
                  多種多様な職種を経験した学生を保有
                </Typography>
              </div>
            </div>
          </li>
        </ul>
      </ContainerLarge>
    </DataContainer>
  )
}

const DataContainer = styled.div`
  background: ${Color.White};
  padding: 96px 0;
  ${IsMobile(css`
    padding: 80px 0;
  `)}
  .section-container {
    position: relative;
    z-index: 0;
  }
  .data-content_group {
    display: flex;
    width: calc(100% + 20px);
    margin: 0 -10px;
    ${IsMobile(css`
      width: 100%;
      flex-direction: column;
      margin: 0;
    `)};
    ${IsPC(css`
      &.first {
        margin-bottom: 48px;
      }
    `)};
  }
  .data-content_item {
    width: 33.3%;
    margin: 0 10px;
    ${IsMobile(css`
      width: 100%;
      margin: 0;
      margin-bottom: 48px;
      &.last {
        margin-bottom: 0;
      }
    `)};
    ${IsPC(css`
      &.half {
        width: 50%;
      }
    `)};
  }
  .data-content_item-title {
    background: ${Color.BackgroundPrimary};
    border-radius: ${RadiusSize.Medium}px;
    padding: ${SpacingSize.XS}px ${SpacingSize.L}px;
    margin-bottom: ${SpacingSize["2XL"]}px;
    ${IsMobile(css`
      margin-bottom: 24px;
    `)};
  }
  .data-content_item-content {
    height: 256px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${IsMobile(css`
      height: auto;
    `)};
  }
  .data-content_item-content-inner {
    text-align: center;
    &.item1 {
      .img {
        height: 94px;
        ${IsMobile(css`
          height: 80px;
        `)}
      }
      .num {
        color: ${Color.Primary};
        font-weight: bold;
        font-size: ${TextSize["3XL"]}px;
        line-height: ${LineHeight.S}%;
        margin-top: ${SpacingSize.S}px;
        .small {
          font-size: ${TextSize.L}px;
        }
        ${IsMobile(css`
          margin-top: 8px;
        `)}
      }
      .subnum {
        color: ${Color.Black};
      }
      .supplement-wrapper {
        width: 232px;
        padding: ${SpacingSize.XS}px;
        border-radius: ${RadiusSize.Medium}px;
        border: 1px solid ${Color.BorderGray};
        margin: ${SpacingSize.S}px auto 0;
        ${IsMobile(css`
          margin-top: 8px;
        `)}
      }
      .supplement {
        font-weight: bold;
      }
    }
    &.item2 {
      .img {
        height: 198px;
        ${IsMobile(css`
          height: 180px;
        `)};
      }
    }
    &.item3 {
      .img {
        height: 256px;
      }
    }
    &.item4 {
      .img {
        height: 216px;
        ${IsMobile(css`
          height: 212px;
        `)};
      }
    }
    &.item5 {
      .img {
        height: 216px;
        ${IsMobile(css`
          height: 195px;
        `)};
      }
    }
    &.item2,
    &.item4,
    &.item5 {
      .summary {
        width: max-content;
        margin: auto;
        color: ${Color.Black};
        padding-bottom: ${SpacingSize["4XS"]}px;
        border-bottom: 2px solid ${Color.Primary};
        margin-top: ${SpacingSize.M}px;
      }
    }
    &.item4 {
      .summary {
        padding-bottom: 0px;
        &.line-after {
          margin-top: ${SpacingSize["3XS"]}px;
        }
      }
    }
  }
`
interface SampleProps {
  onClick: Function
}
const Sample = ({ onClick }: SampleProps) => {
  return (
    <SampleContainer>
      <ContainerLarge className="section-container">
        <Heading subHeading="学生時代から社会で活躍している！" heading="こんな経験を積んだ学生と出会える" />
        <ul className="sample-content_group">
          <li className="sample-content_item">
            <div className="sample-content_item-name-wrapper sample1">
              <div className="sample-content_item-name-group">
                <Typography type="SubHeading" className="sample-content_item-name">
                  Aさん
                </Typography>
                <Typography type="SubLabel" className="sample-content_item-major">
                  東京大学 教養学部文化2類
                </Typography>
              </div>
              <Typography type="SubHeading" className="sample-content_item-occupation">
                営業インターン
              </Typography>
            </div>
            <div className="sample-content_item-main-wrapper">
              <Typography type="SubHeading" className="sample-content_item-title">
                医療系に特化したITベンチャー企業で、病院に対して新規のテレアポ、及びカスタマーサクセスを担当
              </Typography>
              <Typography type="Note" className="sample-content_item-text">
                スタートアップの環境で、指示を待つのでは無く、与えられた目標に対して自分が今何をすべきかを考えて行動をしました。
                <br />
                提案・交渉力については顧客の本当の課題がどこなのか、それを解決するためには何をすればいいのか、また何ができるのかを自分で論理立て、相手に納得してもらう課題解決の過程の中で、何度も壁にぶつかりながら乗り越えたことで身につけました。
              </Typography>
              <Typography type="Note" className="sample-content_item-text line-after">
                <span className="title">学び</span>主体性・提案・交渉力
              </Typography>
            </div>
          </li>
          <li className="sample-content_item">
            <div className="sample-content_item-name-wrapper sample2">
              <div className="sample-content_item-name-group">
                <Typography type="SubHeading" className="sample-content_item-name">
                  Bさん
                </Typography>
                <Typography type="SubLabel" className="sample-content_item-major">
                  同志社大学 法学部
                </Typography>
              </div>
              <Typography type="SubHeading" className="sample-content_item-occupation">
                マーケテイングインターン
              </Typography>
            </div>
            <div className="sample-content_item-main-wrapper">
              <Typography type="SubHeading" className="sample-content_item-title">
                WEBマーケティング支援企業にて、自社のお問合せ数を増やすために、様々なマーケティング施策を実施
              </Typography>
              <Typography type="Note" className="sample-content_item-text">
                社員数が3人の京都支社立ち上げ段階で入社しました。経営の中心に関わり、積極性やハングリー精神の重要性を学びました。
                <br />
                将来目指したい職種が定まっていなかったこともあり、積極的に目標数値を達成するための仕事を自ら考え実行しました。具体的に、メルマガ配信、自社ブログ運営、コンテンツの企画、リサーチ、コンテンツ作成など、目標の数値を達成するために自ら動いたことが、インターンを通じて学べたことでした。
              </Typography>
              <Typography type="Note" className="sample-content_item-text line-after">
                <span className="title">学び</span>積極性・ハングリー精神
              </Typography>
            </div>
          </li>
          <li className="sample-content_item">
            <div className="sample-content_item-name-wrapper sample3">
              <div className="sample-content_item-name-group">
                <Typography type="SubHeading" className="sample-content_item-name">
                  Cさん
                </Typography>
                <Typography type="SubLabel" className="sample-content_item-major">
                  早稲田大学 基幹理工学部
                </Typography>
              </div>
              <Typography type="SubHeading" className="sample-content_item-occupation">
                エンジニアインターン
              </Typography>
            </div>
            <div className="sample-content_item-main-wrapper">
              <Typography type="SubHeading" className="sample-content_item-title">
                ペットを一時期預かって欲しい飼い主と近くの愛犬家が出会えるCtoCマッチングサービス
              </Typography>
              <Typography type="Note" className="sample-content_item-text">
                小学生からプログラミング行なっており、サービス開発や各言語の知識はありました。しかし、実務の中での開発経験はなかったため、複数人での運用を見据えた実装方法は大きな学びでした。上記以外でも、プライベートや授業で様々な言語の使用経験があります。
              </Typography>
              <Typography type="Note" className="sample-content_item-text line-after">
                <span className="title">学び</span>
                運用を見据えた開発経験・複数人での開発経験・開発作業の自動化経験
              </Typography>
              <Typography type="Note" className="sample-content_item-text line-after">
                <span className="title">開発言語</span>
                <span className="subtitle">Webアプリケーション開発：</span>
                <br />
                （フロント）JavaScript/TypeScript
                <br />
                （サーバーサイト）PHP/Ruby
                <br />
                <span className="subtitle">iOSアプリケーション開発：</span>Swift
                <br />
                <span className="subtitle">IoT開発：</span>Dart (Flutter)/Rust
              </Typography>
            </div>
          </li>
        </ul>
        <div className="sample-content_CV">
          <div>
            <Pc>
              <Typography type="SubHeading" className="sample-content_CV-main-message">
                学生についてもっと知りたい方は、サービス資料請求！
              </Typography>
              <Typography type="Description" className="sample-content_CV-sub-message">
                学生のプロフィールや業務内容をさらに詳しくお伝えします。
              </Typography>
            </Pc>
            <Sp>
              <Typography type="SubHeading" className="sample-content_CV-main-message">
                学生についてもっと知りたい方は、
                <br />
                サービス資料請求！
              </Typography>
              <Typography type="SubNote" className="sample-content_CV-sub-message">
                学生のプロフィールや業務内容を
                <br />
                さらに詳しくお伝えします。
              </Typography>
            </Sp>
          </div>
          <Button size="Medium" onClick={onClick} className="sample-content_CV-button">
            資料請求・お問い合わせ
          </Button>
        </div>
      </ContainerLarge>
    </SampleContainer>
  )
}

const SampleContainer = styled.div`
  background: ${Color.BackgroundGray};
  padding: 96px 0;
  .section-container {
    position: relative;
    z-index: 0;
  }
  .sample-content_group {
    display: flex;
    ${IsPC(css`
      margin: 0 -10px;
      width: calc(100% + 20px);
    `)};
    ${IsMobile(css`
      width: 100%;
      flex-direction: column;
    `)};
  }
  .sample-content_item {
    width: 33%;
    border-radius: ${RadiusSize.Medium}px;
    overflow: hidden;
    background: ${Color.White};
    ${Shadow.Deep};
    ${IsPC(css`
      margin: 0 10px;
    `)};
    ${IsMobile(css`
      width: 100%;
      margin-bottom: 20px;
    `)};
  }
  .sample-content_item-name-wrapper {
    background-image: url(${staticPath("/static/images/short-internship/corp-contact/sample-1.png")});
    background-position: center;
    background-size: cover;
    padding: ${SpacingSize.M}px ${SpacingSize.L}px;
    &.sample2 {
      background-image: url(${staticPath("/static/images/short-internship/corp-contact/sample-2.png")});
    }
    &.sample3 {
      background-image: url(${staticPath("/static/images/short-internship/corp-contact/sample-3.png")});
    }
    ${IsMobile(css`
      padding: 12px 20px;
    `)}
  }
  .sample-content_item-name-group {
    display: flex;
    align-items: center;
  }
  .sample-content_item-name {
    color: ${Color.White};
    text-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  }
  .sample-content_item-major {
    color: ${Color.White};
    margin-left: ${SpacingSize.S}px;
    text-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  }
  .sample-content_item-occupation {
    color: ${Color.White};
    background: ${Color.Primary};
    border-radius: ${RadiusSize.Medium}px;
    width: max-content;
    margin-top: ${SpacingSize["3XS"]}px;
    padding: ${SpacingSize["4XS"]}px ${SpacingSize.S}px;
  }
  .sample-content_item-main-wrapper {
    padding: ${SpacingSize.M}px ${SpacingSize.L}px;
    ${IsMobile(css`
      padding: 16px 20px 20px;
    `)}
  }
  .sample-content_item-title {
    ${IsMobile(css`
      font-size: 16px;
    `)}
  }
  .sample-content_item-text {
    margin-top: ${SpacingSize.S}px;
    ${IsMobile(css`
      margin-top: 8px;
      font-size: 13px;
    `)}
    &.line-after {
      margin-top: ${SpacingSize["3XS"]}px;
    }
    .title {
      color: ${Color.Primary};
      font-weight: bold;
      margin-right: ${SpacingSize["3XS"]}px;
    }
    .subtitle {
      font-weight: bold;
    }
  }
  .sample-content_CV {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${Color.White};
    ${Shadow.Deep};
    padding: ${SpacingSize["2XL"]}px 80px ${SpacingSize["2XL"]}px 80px;
    margin-top: ${SpacingSize["2XL"]}px;
    border-radius: ${RadiusSize.Medium}px;
    ${IsMobile(css`
      padding: 20px;
      flex-direction: column;
      margin: 0;
      text-align: center;
    `)};
  }
  .sample-content_CV-sub-message {
    color: ${Color.Gray};
    margin-top: ${SpacingSize["3XS"]}px;
    ${IsMobile(css`
      font-size: 12px;
    `)};
  }
  .sample-content_CV-button {
    width: 260px;
    ${IsMobile(css`
      margin-top: 16px;
    `)};
  }
`

const Performance = () => {
  return (
    <PerformanceContainer>
      <ContainerLarge className="section-container">
        <Pc>
          <Heading
            subHeading="なぜ、キャリア意識の高い学生が集まる？"
            heading="業界屈指の長期インターン求人サービスでの実績"
          />
          <Typography type="SubHero" className="performance-content_subheading">
            長期インターン求人サイトの実績
          </Typography>
          <ul className="performance-content_group first">
            <li className="performance-content_item">
              <Typography type="SubHeading" className="performance-content_item-title">
                長期インターン求人サービス
              </Typography>
              <Typography type="Heading" className="performance-content_item-num">
                <span className="big">５</span>年間運営
              </Typography>
            </li>
            <li className="performance-content_item">
              <Typography type="SubHeading" className="performance-content_item-title">
                累計登録学生
              </Typography>
              <Typography type="Heading" className="performance-content_item-num">
                <span className="big">53,000</span>人
              </Typography>
            </li>
            <li className="performance-content_item">
              <Typography type="SubHeading" className="performance-content_item-title">
                長期インターン累計輩出数
              </Typography>
              <Typography type="Heading" className="performance-content_item-num">
                <span className="big">3,000</span>人
              </Typography>
            </li>
          </ul>
          <ul className="performance-content_group">
            <li className="performance-content_item dobble">
              <Typography type="SubHeading" className="performance-content_item-title">
                インターン系の検索SEO
              </Typography>
              <div className="performance-content_item-SEO-wrapper">
                <ul className="performance-content_item-SEO-area">
                  <li className="performance-content_item-SEO-item">
                    <Typography type="Label" className="performance-content_item-SEO-word">
                      長期インターン
                    </Typography>
                    <Icon type="Search" size={16} color={Color.Primary} />
                  </li>
                  <li className="performance-content_item-SEO-item">
                    <Typography type="Label" className="performance-content_item-SEO-word">
                      サマーインターン
                    </Typography>
                    <Icon type="Search" size={16} color={Color.Primary} />
                  </li>
                </ul>
                <Typography type="Heading" className="performance-content_item-num dobble">
                  常時<span className="big">1〜3</span>位
                </Typography>
              </div>
              <Typography type="Label" className="performance-content_item-supplement">
                その他インターン系キーワード 上位常連
              </Typography>
            </li>
            <li className="performance-content_item">
              <Typography type="SubHeading" className="performance-content_item-title">
                累計掲載社数
              </Typography>
              <Typography type="Heading" className="performance-content_item-num">
                <span className="big">1,000</span>社
              </Typography>
            </li>
          </ul>
        </Pc>
        <Sp>
          <Heading
            subHeading="なぜ、キャリア意識の高い学生が集まる？"
            heading="業界屈指の長期インターン"
            heading2="求人サービスでの実績"
          />
          <Typography type="Heading" className="performance-content_subheading">
            長期インターン求人サイトの実績
          </Typography>
          <ul className="performance-content_group first">
            <li className="performance-content_item">
              <Typography type="Label" className="performance-content_item-title">
                長期インターン
                <br />
                求人サービス
              </Typography>
              <Typography type="SubHeading" className="performance-content_item-num">
                <span className="big">５</span>年間運営
              </Typography>
            </li>
            <li className="performance-content_item">
              <Typography type="Label" className="performance-content_item-title">
                累計
                <br />
                登録学生
              </Typography>
              <Typography type="SubHeading" className="performance-content_item-num">
                <span className="big">42,000</span>人
              </Typography>
            </li>
          </ul>
          <ul className="performance-content_group first">
            <li className="performance-content_item">
              <Typography type="Label" className="performance-content_item-title">
                長期インターン
                <br />
                累計輩出数
              </Typography>
              <Typography type="SubHeading" className="performance-content_item-num">
                <span className="big">3,000</span>人
              </Typography>
            </li>
            <li className="performance-content_item">
              <Typography type="Label" className="performance-content_item-title">
                累計
                <br />
                掲載社数
              </Typography>
              <Typography type="SubHeading" className="performance-content_item-num">
                <span className="big">1,000</span>社
              </Typography>
            </li>
          </ul>
          <ul className="performance-content_group">
            <li className="performance-content_item dobble">
              <Typography type="Label" className="performance-content_item-title">
                インターン系の検索SEO
              </Typography>
              <div className="performance-content_item-SEO-wrapper">
                <ul className="performance-content_item-SEO-area">
                  <li className="performance-content_item-SEO-item">
                    <Typography type="Label" className="performance-content_item-SEO-word">
                      長期インターン
                    </Typography>
                    <Icon type="Search" size={16} color={Color.Primary} />
                  </li>
                  <li className="performance-content_item-SEO-item">
                    <Typography type="Label" className="performance-content_item-SEO-word">
                      サマーインターン
                    </Typography>
                    <Icon type="Search" size={16} color={Color.Primary} />
                  </li>
                </ul>
                <Typography type="SubHeading" className="performance-content_item-num dobble">
                  常時
                  <br />
                  <span className="big">1〜3</span>位
                </Typography>
              </div>
              <Typography type="SubLabel" className="performance-content_item-supplement">
                その他インターン系キーワード 上位常連
              </Typography>
            </li>
          </ul>
        </Sp>
        <div className="performance-content_connect">
          <img
            className="performance-content_connect-arrow"
            src={`${staticPath("/static/images/short-internship/corp-contact/performance-arrow-under.svg")}`}
          />
          <Typography type="Heading" colorProp={Color.White} className="performance-content_connect-text">
            業界屈指の長期インターンサービスを
            <br className="pc-hide" />
            活用して集客！
          </Typography>
        </div>
        <Pc>
          <Typography type="SubHero" className="performance-content_subheading">
            短期インターンの集客実績
          </Typography>
          <ul className="performance-content_group first">
            <li className="performance-content_item">
              <Typography type="SubHeading" className="performance-content_item-title">
                マーケティング職の応募
              </Typography>
              <Typography type="Heading" className="performance-content_item-num">
                <span className="big">105</span>名/2ヵ月
              </Typography>
              <Typography type="Note" lineHeightProp={140} className="performance-content_item-info">
                事業内容：データ・広告
                <br />
                従業員　：500名
              </Typography>
            </li>
            <li className="performance-content_item">
              <Typography type="SubHeading" className="performance-content_item-title">
                エンジニア職の応募
              </Typography>
              <Typography type="Heading" className="performance-content_item-num">
                <span className="big">30</span>名/2ヵ月
              </Typography>
              <Typography type="Note" lineHeightProp={140} className="performance-content_item-info">
                事業内容：マッチングサービス運営
                <br />
                従業員　：150名
              </Typography>
            </li>
            <li className="performance-content_item">
              <Typography type="SubHeading" className="performance-content_item-title">
                営業職の応募
              </Typography>
              <Typography type="Heading" className="performance-content_item-num">
                <span className="big">30</span>名/2ヵ月
              </Typography>
              <Typography type="Note" lineHeightProp={140} className="performance-content_item-info">
                事業内容：オフィスコンサルティング
                <br />
                従業員　：250名
              </Typography>
            </li>
          </ul>
        </Pc>
        <Sp>
          <Typography type="Heading" className="performance-content_subheading">
            短期インターンの集客実績
          </Typography>
          <ul className="performance-content_group first">
            <li className="performance-content_item dobble">
              <Typography type="Label" className="performance-content_item-title">
                マーケティング職の応募
              </Typography>
              <Typography type="SubHeading" className="performance-content_item-num">
                <span className="big">105</span>名/2ヵ月
              </Typography>
              <Typography type="Note" lineHeightProp={140} className="performance-content_item-info">
                事業内容：データ・広告
                <br />
                従業員　：500名
              </Typography>
            </li>
          </ul>
          <ul className="performance-content_group first">
            <li className="performance-content_item dobble">
              <Typography type="Label" className="performance-content_item-title">
                エンジニア職の応募
              </Typography>
              <Typography type="SubHeading" className="performance-content_item-num">
                <span className="big">30</span>名/2ヵ月
              </Typography>
              <Typography type="Note" lineHeightProp={140} className="performance-content_item-info">
                事業内容：マッチングサービス運営
                <br />
                従業員　：150名
              </Typography>
            </li>
          </ul>

          <ul className="performance-content_group first">
            <li className="performance-content_item dobble">
              <Typography type="Label" className="performance-content_item-title">
                営業職の応募
              </Typography>
              <Typography type="SubHeading" className="performance-content_item-num">
                <span className="big">30</span>名/2ヵ月
              </Typography>
              <Typography type="Note" lineHeightProp={140} className="performance-content_item-info">
                事業内容：オフィスコンサルティング
                <br />
                従業員　：250名
              </Typography>
            </li>
          </ul>
        </Sp>
      </ContainerLarge>
    </PerformanceContainer>
  )
}

const PerformanceContainer = styled.div`
  background: ${Color.BackgroundPrimary};
  padding: 96px 0 calc(96px + 92px);
  ${IsMobile(css`
    padding: 80px 0 calc(80px + 83px);
  `)}
  .section-container {
    position: relative;
    z-index: 0;
  }
  .performance-content_group {
    display: flex;
    width: 100%;
    &.first {
      margin-bottom: ${SpacingSize.L}px;
      ${IsMobile(css`
        margin-bottom: 12px;
      `)}
    }
  }
  .performance-content_subheading {
    text-align: center;
    margin-bottom: 20px;
  }
  .performance-content_item {
    background: ${Color.White};
    height: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 33.3%;
    text-align: center;
    &.dobble {
      width: calc((100% + 20px) - 33.3%);
    }
    &:not(:first-child) {
      margin-left: ${SpacingSize.L}px;
    }
    ${IsMobile(css`
      padding: 32px 4px;
      height: auto;
      width: 50%;
      &:not(:first-child) {
        margin-left: 12px;
      }
      &.dobble {
        padding: 32px 20px;
        width: 100%;
      }
    `)}
  }
  .performance-content_item-title {
    color: ${Color.Black};
  }
  .performance-content_item-num {
    margin-top: ${SpacingSize.M}px;
    color: ${Color.Primary};
    .big {
      font-size: 40px;
      ${IsMobile(css`
        font-size: 28px;
      `)}
    }
    &.dobble {
      margin: 0;
      text-align: left;
      line-height: 160%;
    }
  }
  .performance-content_item-info {
    margin-top: 12px;
    text-align: left;
    width: 240px;
  }
  .performance-content_item-supplement {
    margin-top: ${SpacingSize.S}px;
    padding: ${SpacingSize["3XS"]}px ${SpacingSize.M}px;
    color: ${Color.LightGray};
    background: ${Color.BackgroundGray};
    border-radius: ${RadiusSize.Medium}px;
    ${IsMobile(css`
      padding: 4px;
      width: 100%;
    `)}
  }
  .performance-content_item-SEO-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: ${SpacingSize.S}px;
    ${IsMobile(css`
      width: 100%;
      justify-content: space-between;
    `)}
  }
  .performance-content_item-SEO-area {
    margin-right: ${SpacingSize["2XL"]}px;
    ${IsMobile(css`
      margin: 0;
    `)}
  }
  .performance-content_item-SEO-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${SpacingSize["4XS"]}px ${SpacingSize.S}px ${SpacingSize["4XS"]}px ${SpacingSize.M}px;
    border-radius: 30px;
    border: 1px solid ${Color.BorderGray};
    &:first-child {
      margin-bottom: ${SpacingSize["3XS"]}px;
    }
  }
  .performance-content_item-SEO-word {
    color: ${Color.Black};
    margin-right: ${SpacingSize.XL}px;
  }
  .performance-content_connect {
    padding: 20px 0;
  }
  .performance-content_connect-text {
    padding: 14px;
    max-width: 560px;
    background: ${Color.Primary};
    border-radius: 28px;
    text-align: center;
    margin: -92px auto 36px;
    ${IsMobile(css`
      font-size: 16px;
      padding: 6px;
    `)}
  }
  .performance-content_connect-arrow {
    display: block;
    margin: auto;
  }
  .pc-hide {
    display: none;
    ${IsMobile(css`
      display: inline;
    `)}
  }
`

const Service = () => {
  return (
    <ServiceContainer>
      <ContainerLarge className="section-container">
        <Heading subHeading="貴社の課題感にあったアプローチ！" heading="Infraでできること" />
        <ul className="service-content_group">
          <li className="service-content_item">
            <div className="service-content_item-img">
              <Sp>
                <img
                  className="service-content_item-num"
                  src={`${staticPath("/static/images/short-internship/corp-contact/service-num-1.png")}`}
                />
              </Sp>
            </div>
            <div className="service-content_item-text-wrapper">
              <Pc>
                <img
                  className="service-content_item-num"
                  src={`${staticPath("/static/images/short-internship/corp-contact/service-num-1.png")}`}
                />
              </Pc>
              <Typography type="Label" className="service-content_item-subtitle">
                様々な手段で学生との接点を。
                <br />
                母集団形成の確保！
              </Typography>
              <Typography type="Hero" className="service-content_item-title">
                媒体掲載
              </Typography>
              <Typography type="Description" className="service-content_item-supplement">
                短期インターン、イベントに掲載し、様々な手段により母集団形成を確保することができます。
              </Typography>
            </div>
          </li>

          <li className="service-content_item left">
            <div className="service-content_item-img img2">
              <Sp>
                <img
                  className="service-content_item-num left"
                  src={`${staticPath("/static/images/short-internship/corp-contact/service-num-2.png")}`}
                />
              </Sp>
            </div>
            <div className="service-content_item-text-wrapper left">
              <Pc>
                <img
                  className="service-content_item-num left"
                  src={`${staticPath("/static/images/short-internship/corp-contact/service-num-2.png")}`}
                />
              </Pc>
              <Typography type="Label" className="service-content_item-subtitle">
                自社に合う学生を選び、スカウト。
                <br />
                状況に合わせた採用コントロールが自在！
              </Typography>
              <Typography type="Hero" className="service-content_item-title">
                ダイレクトリクルーティング
              </Typography>
              <Typography type="Description" className="service-content_item-supplement">
                インターンや課外活動の経験やスキル、就職希望などの条件で絞り込み、求める学生をスカウトできます。
              </Typography>
            </div>
          </li>

          <li className="service-content_item">
            <div className="service-content_item-img img3">
              <Sp>
                <img
                  className="service-content_item-num"
                  src={`${staticPath("/static/images/short-internship/corp-contact/service-num-3.png")}`}
                />
              </Sp>
            </div>
            <div className="service-content_item-text-wrapper">
              <Pc>
                <img
                  className="service-content_item-num"
                  src={`${staticPath("/static/images/short-internship/corp-contact/service-num-3.png")}`}
                />
              </Pc>
              <Typography type="Label" className="service-content_item-subtitle">
                ユニークな企画に集まった学生に
                <br />
                直接コンタクト。十二分の魅力付け！
              </Typography>
              <Typography type="Hero" className="service-content_item-title">
                イベント
              </Typography>
              <Typography type="Description" className="service-content_item-supplement">
                学生の課題感や指向性のデータを元に貴社の要望に合った学生を集めるイベントを企画し学生との接点を作ります。
              </Typography>
            </div>
          </li>
        </ul>
      </ContainerLarge>
    </ServiceContainer>
  )
}

const ServiceContainer = styled.div`
  background: ${Color.BackgroundGray};
  padding: calc(96px + 92px) 0 96px;
  ${IsMobile(css`
    padding: calc(80px + 83px) 0 80px;
  `)}
  .section-container {
    position: relative;
    z-index: 0;
  }
  .service-content_item {
    display: flex;
    ${IsPC(css`
      margin: 0 10px 88px;
    `)};
    ${IsMobile(css`
      flex-direction: column;
      align-items: center;
      width: 100%;
      margin-bottom: 40px;
    `)};
    &.left {
      ${IsPC(css`
        margin: 0 10px 48px;
        flex-direction: row-reverse;
      `)};
    }
  }
  .service-content_item-img {
    position: relative;
    z-index: 1;
    width: 480px;
    height: 280px;
    background-image: url(${staticPath("/static/images/short-internship/corp-contact/service-img-1.png")});
    background-position: center;
    background-size: cover;
    overflow: hidden;
    ${Shadow.Deep};
    border-radius: ${RadiusSize.Medium}px;
    &.img2 {
      background-image: url(${staticPath("/static/images/short-internship/corp-contact/service-img-2.png")});
    }
    &.img3 {
      background-image: url(${staticPath("/static/images/short-internship/corp-contact/service-img-3.png")});
    }
    &.img4 {
      background-image: url(${staticPath("/static/images/short-internship/corp-contact/service-img-4.png")});
    }
    ${IsMobile(css`
      width: 100%;
      height: 180px;
    `)};
  }
  .service-content_item-text-wrapper {
    position: relative;
    max-width: 634px;
    height: max-content;
    padding: 60px 84px 60px 154px;
    background: ${Color.White};
    margin-left: -114px;
    margin-top: ${SpacingSize["3XL"]}px;
    border-radius: ${RadiusSize.Medium}px;
    &.left {
      padding: 60px 154px 60px 84px;
      margin: 0;
      margin-right: -114px;
      margin-top: -40px;
    }
    ${IsMobile(css`
      margin: -12px -16px 0;
      padding: 36px 16px 24px;
      border-radius: 0;
      &.left {
        margin: -12px -16px 0;
        padding: 36px 16px 24px;
      }
    `)};
  }
  .service-content_item-num {
    position: absolute;
    width: 80px;
    top: 0;
    right: 0;
    &.left {
      top: 0;
      left: 0;
    }
  }
  .service-content_item-subtitle {
    color: ${Color.Black};
    margin-bottom: ${SpacingSize.XS}px;
    ${IsMobile(css`
      font-size: 12px;
      margin-bottom: 4px;
    `)};
  }
  .service-content_item-title {
    color: ${Color.Primary};
    margin-bottom: ${SpacingSize.XL}px;
    ${IsMobile(css`
      font-size: 24px;
      margin-bottom: 8px;
    `)};
  }
  .service-content_item-supplement {
    color: ${Color.LightGray};
  }
`

const Company = () => {
  return (
    <CompanyContainer>
      <ContainerLarge className="section-container">
        <Heading subHeading="すでに多くの企業様にご利用いただいてます" heading="サービス利用企業" />
        <ul className="company-content_logo-wrapper">
          {[1, 2, 3, 4, 5].map(() => (
            <li className="company-content_logo-item" />
          ))}
        </ul>
      </ContainerLarge>
    </CompanyContainer>
  )
}

const CompanyContainer = styled.div`
  background: ${Color.White};
  padding: 96px 0 calc(96px + 92px);
  ${IsMobile(css`
    padding: 80px 0 calc(80px + 83px);
  `)}
  .section-container {
    position: relative;
    z-index: 0;
  }
  .company-content_logo-wrapper {
    display: flex;
    ${IsMobile(css`
      flex-wrap: wrap;
      justify-content: center;
    `)}
  }
  .company-content_logo-item {
    display: flex;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: calc((100% - 80px) / 5);
    height: 98px;
    content: "";
    margin-right: 20px;
    ${IsMobile(css`
      width: calc((100% - 20px) / 3);
      margin-right: 10px;
      &:nth-child(3n) {
        margin: 0;
      }
    `)}
    &:nth-child(1) {
      background-image: url(${staticPath("/static/images/short-internship/corp-contact/company-logo-microad.png")});
    }
    &:nth-child(2) {
      background-image: url(${staticPath("/static/images/short-internship/corp-contact/company-logo-cyberagent.png")});
    }
    &:nth-child(3) {
      background-image: url(${staticPath("/static/images/short-internship/corp-contact/company-logo-eureka.png")});
    }
    &:nth-child(4) {
      background-image: url(${staticPath("/static/images/short-internship/corp-contact/company-logo-maff.png")});
    }
    &:nth-child(5) {
      background-image: url(${staticPath(
        "/static/images/short-internship/corp-contact/company-logo-philipmorris.png"
      )});
      margin: 0;
    }
  }
  .company-content_graph-wrapper {
    text-align: center;
    margin-bottom: 96px;
    ${IsMobile(css`
      margin-bottom: 48px;
    `)}
  }
  .company-content_graph-subtitle {
    position: relative;
    color: ${Color.Primary};
    margin: 0 auto ${SpacingSize["3XS"]}px;
    width: max-content;
    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 2px;
      height: 18px;
      background: ${Color.Primary};
      bottom: 2px;
    }
    &:before {
      transform: rotate(30deg);
      right: -12px;
    }
    &:after {
      transform: rotate(-30deg);
      left: -12px;
    }
    ${IsMobile(css`
      font-size: 14px;
      &:before,
      &:after {
        height: 14px;
      }
    `)}
  }
  .company-content_graph-title {
    margin-bottom: ${SpacingSize.XS}px;
    .color {
      color: ${Color.Primary};
    }
    .big {
      font-size: 32px;
    }
    ${IsMobile(css`
      font-size: 16px;
      .big {
        font-size: 24px;
      }
    `)}
  }
  .company-content_graph-img {
    width: 582px;
    ${IsMobile(css`
      padding-right: 8px;
      width: 100%;
      max-width: 420px;
    `)}
  }
  .company-content_voice-wrapper {
  }
  .company-content_voice-title {
    position: relative;
    margin-bottom: ${SpacingSize.XL}px;
    width: max-content;
    ${IsMobile(css`
      font-size: 16px;
    `)}
    &:after {
      position: absolute;
      content: "";
      width: 20px;
      height: 20px;
      top: -12px;
      right: -22px;
      background-image: url(${staticPath("/static/images/short-internship/corp-contact/company-voice-icon.png")});
      background-position: center;
      background-size: cover;
      ${IsMobile(css`
        width: 16px;
        height: 16px;
        top: -10px;
        right: -18px;
        margin-bottom: 20px;
      `)}
    }
  }
  .company-content_voice-group {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;
    margin: -10px;
    ${IsPC(css`
      margin: -10px calc((100vw - 1000px) / 2 * (-1));
      padding: 0 calc((100vw - 1000px) / 2 - 10px);
      &:after {
        display: table;
        content: "";
        width: 16px;
        height: 10px;
      }
    `)}
    ${IsMobile(css`
      margin: -10px calc(-16px - 10px);
      padding: 0 16px;
      &:after {
        display: table;
        content: "";
        width: 16px;
        height: 10px;
      }
    `)}
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .company-content_voice-item {
    flex-grow: 0;
    flex-shrink: 0;
    width: 640px;
    padding: ${SpacingSize["2XL"]}px ${SpacingSize["4XL"]}px;
    border-radius: ${RadiusSize.Medium}px;
    ${Shadow.Deep};
    margin: 10px;
    background: ${Color.White};
    ${IsMobile(css`
      width: 300px;
      padding: 20px;
    `)}
  }
  .company-content_voice-item-title {
    padding-bottom: ${SpacingSize.M}px;
    &:after {
      display: block;
      content: "";
      height: 3px;
      width: 60px;
      background: ${Color.Primary};
      border-radius: 3px;
      margin: ${SpacingSize.M}px auto 0 0;
    }
    ${IsMobile(css`
      font-size: 16px;
      padding-bottom: 12px;
    `)}
    .br-pc {
      ${IsMobile(css`
        display: none;
      `)}
    }
  }
  .company-content_voice-item-name {
    ${IsMobile(css`
      font-size: 14px;
    `)}
  }
  .company-content_voice-item-comment {
    margin-top: ${SpacingSize.XS}px;
    ${IsMobile(css`
      font-size: 12px;
    `)}
  }
`

interface PlanProps {
  onClick: Function
}
const Plan = ({ onClick }: PlanProps) => {
  return (
    <PlanContainer>
      <ContainerLarge className="section-container">
        <Heading subHeading="ニーズに合わせてオーダーメイド！" heading="ご契約プラン" />
        <ul className="plan-content_group">
          <li className="plan-content_item">
            <div className="plan-content_item-title-area">
              <Typography type="Note" className="plan-content_item-supplement">
                コストを最低限抑えたい企業様に
              </Typography>
              <Typography type="SubHero" className="plan-content_item-title">
                成果報酬プラン
              </Typography>
            </div>
            <Typography type="Heading" className="plan-content_item-price">
              <span className="big">35</span>万円〜
              <span className="big">75</span>万円/人
            </Typography>
          </li>
          <li className="plan-content_item">
            <div className="plan-content_item-title-area">
              <Typography type="Note" className="plan-content_item-supplement">
                優秀層の認知や集客を必要としている企業様に
              </Typography>
              <Typography type="SubHero" className="plan-content_item-title">
                掲載課金プラン
              </Typography>
            </div>
            <Typography type="Heading" className="plan-content_item-price">
              <span className="big">6.6</span>万円/月〜
            </Typography>
          </li>
          <li className="plan-content_item">
            <div className="plan-content_item-title-area">
              <Typography type="Note" className="plan-content_item-supplement">
                効率よく採用活動をしたい企業様に
              </Typography>
              <Typography type="SubHero" className="plan-content_item-title">
                送客プラン
              </Typography>
            </div>
            <Typography type="Heading" className="plan-content_item-price">
              <span className="big">3</span>千円〜<span className="big">1</span>
              万円/人
            </Typography>
          </li>
          <li className="plan-content_item">
            <div className="plan-content_item-title-area">
              <Typography type="Note" className="plan-content_item-supplement">
                就活生との接点を持ちたい企業様に
              </Typography>
              <Typography type="SubHero" className="plan-content_item-title">
                イベント開催プラン
              </Typography>
            </div>
            <Typography type="Heading" className="plan-content_item-price">
              <span className="big">20</span>万円/回〜
            </Typography>
          </li>
        </ul>
        <div className="plan-content_CV">
          <div>
            <Pc>
              <Typography type="SubHeading" className="plan-content_CV-main-message">
                その他、採用ニーズに合わせてカスタマイズ可能です。
              </Typography>
              <Typography type="Description" className="plan-content_CV-sub-message">
                詳しくはサービス資料請求・お問い合わせをしてください。
              </Typography>
            </Pc>
            <Sp>
              <Typography type="SubHeading" className="plan-content_CV-main-message">
                その他、採用ニーズに合わせて
                <br />
                カスタマイズ可能です。
              </Typography>
              <Typography type="SubNote" className="plan-content_CV-sub-message">
                詳しくはサービス資料請求・
                <br />
                お問い合わせをしてください。
              </Typography>
            </Sp>
          </div>
          <Button size="Medium" onClick={onClick} className="plan-content_CV-button">
            資料請求・お問い合わせ
          </Button>
        </div>
      </ContainerLarge>
    </PlanContainer>
  )
}

const PlanContainer = styled.div`
  background: ${Color.BackgroundPrimary};
  padding: calc(96px + 92px) 0 96px;
  ${IsMobile(css`
    padding: calc(80px + 83px) 0 80px;
  `)}
  .section-container {
    position: relative;
    z-index: 0;
  }
  .plan-content_group {
    max-width: 780px;
    margin: 0 auto -10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    ${IsMobile(css`
      margin: 0;
    `)}
  }
  .plan-content_item {
    width: calc(50% - 20px);
    margin: 10px;
    background: ${Color.White};
    ${Shadow.Deep};
    text-align: center;
    border-radius: ${RadiusSize.Medium}px;
    overflow: hidden;
    ${IsMobile(css`
      width: 100%;
      margin: 0 0 20px;
    `)}
  }
  .plan-content_item-title-area {
    background: ${Color.Primary};
    padding: ${SpacingSize.XL}px ${SpacingSize.XS}px;
    ${IsMobile(css`
      padding: 20px 4px;
    `)}
  }
  .plan-content_item-supplement {
    color: ${Color.White};
    margin-bottom: ${SpacingSize.XS}px;
    ${IsMobile(css`
      font-size: 12px;
      margin-bottom: 4px;
    `)}
  }
  .plan-content_item-title {
    color: ${Color.White};
    ${IsMobile(css`
      font-size: 20px;
    `)}
  }
  .plan-content_item-price {
    padding: ${SpacingSize["2XL"]}px ${SpacingSize.XS}px ${SpacingSize["3XL"]}px;
    .big {
      font-size: ${TextSize["3XL"]}px;
    }
    ${IsMobile(css`
      padding: 40px 8px;
      font-size: 16px;
      .big {
        font-size: 28px;
      }
    `)}
  }

  .plan-content_CV {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${Color.White};
    ${Shadow.Deep};
    padding: ${SpacingSize["2XL"]}px 80px ${SpacingSize["2XL"]}px 80px;
    margin-top: ${SpacingSize["2XL"]}px;
    border-radius: ${RadiusSize.Medium}px;
    ${IsMobile(css`
      padding: 20px;
      flex-direction: column;
      margin: 0;
      text-align: center;
    `)};
  }
  .plan-content_CV-sub-message {
    color: ${Color.Gray};
    margin-top: ${SpacingSize["3XS"]}px;
    ${IsMobile(css`
      font-size: 12px;
    `)};
  }
  .plan-content_CV-button {
    width: 260px;
    ${IsMobile(css`
      margin-top: 16px;
    `)};
  }
`

interface FormProps {
  complete: boolean
}
const Form = ({ complete }: FormProps) => {
  return (
    <FormContainer id="form">
      <ContainerLarge className="section-container">
        <Typography type="SubHero" className="form-content_heading">
          サービス資料請求・お問い合わせ
        </Typography>
        <div className="form-content_group">
          {/* NOTE: なぜかFeedbackMessageだとリダイレクト後にスタイルが当たらないのでここでスタイルを当てている */}
          {complete && (
            <p className="submit-complete-text">お問い合わせが完了しました。2営業日以内に担当よりご連絡致します。</p>
          )}
          <div className="form-content_item">
            <Pc>
              <iframe
                id="google-form"
                src="https://docs.google.com/forms/d/e/1FAIpQLScPrgb-jAc9l25PcY7xdaHwOjnYSLJjqLX7ZZ7N6lyBQhnhZg/viewform?embedded=true"
                width="100%"
                height="1610"
              >
                読み込んでいます…
              </iframe>
            </Pc>
            <Sp>
              <iframe
                id="google-form"
                src="https://docs.google.com/forms/d/e/1FAIpQLScPrgb-jAc9l25PcY7xdaHwOjnYSLJjqLX7ZZ7N6lyBQhnhZg/viewform?embedded=true"
                width="100%"
                height="1760"
              >
                読み込んでいます…
              </iframe>
            </Sp>
          </div>
        </div>
      </ContainerLarge>
    </FormContainer>
  )
}

const FormContainer = styled.div`
  background: ${Color.BackgroundGray};
  padding: calc(96px + 92px) 0 96px;
  ${IsMobile(css`
    padding: calc(80px + 83px) 0 80px;
  `)}
  .section-container {
    position: relative;
    z-index: 0;
  }
  .form-content_heading {
    margin-bottom: ${SpacingSize["4XL"]}px;
    text-align: center;
    ${IsMobile(css`
      font-size: 20px;
    `)}
    &:after {
      display: block;
      content: "";
      height: 3px;
      width: 60px;
      background: ${Color.Primary};
      border-radius: 3px;
      margin: ${SpacingSize.M}px auto;
    }
  }
  .form-content_group {
    max-width: 640px;
    margin: auto;
    background: ${Color.White};
    padding: ${SpacingSize["2XL"]}px;
    ${IsMobile(css`
      // padding: 32px 16px;
      padding: 8px 0;
    `)}
  }
  .submit-complete-text {
    padding: ${SpacingSize.M}px;
    font-size: ${TextSize.M}px;
    line-height: ${LineHeight.S}%;
    border-radius: ${RadiusSize.Small}px;
    border: 1px solid ${Color.Primary};
    color: ${Color.Primary};
    background-color: ${Color.BackgroundPrimary};
  }
  .form-content_item {
    margin-bottom: ${SpacingSize.XL}px;
  }
  .form-content_button {
    max-width: 260px;
    margin: auto;
  }
`

interface StyledProps {
  open: boolean
}
interface DialogProps {
  onClick: Function
  open: boolean
}

const Dialog = ({ open, onClick }: DialogProps) => {
  return (
    <div>
      <DialogContainer open={open}>
        <Typography type="Heading" className="dialog-heading">
          送信が完了しました！
        </Typography>
        <Typography type="Note" className="dialog-description">
          1週間以内に、メールアドレス宛にご返信いたします。
          <br />
          少々お待ちください。
        </Typography>
        <Icon type="Success" size={64} color={Color.Secondary} className="dialog-icon" />
        <FunctionLink size="Medium" onClick={onClick} className="dialog-link">
          閉じる
        </FunctionLink>
      </DialogContainer>
      <DialogOverlay open={open} />
    </div>
  )
}

const DialogContainer = styled.div`
  width: 80%;
  max-width: 400px;
  margin: auto;
  padding: 24px;
  display: none;
  position: fixed;
  top: 30vh;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: ${Color.White};
  border-radius: ${RadiusSize.Medium}px;
  ${Shadow.Deep};
  ${({ open }: StyledProps) => css`
    ${open &&
    css`
      display: block;
    `}
  `}
  .dialog-heading {
    margin-bottom: 4px;
  }
  .dialog-description {
    margin-bottom: ${SpacingSize.XL}px;
  }
  .dialog-icon {
    margin: 24px auto;
    display: block;
    text-align: center;
  }
  .dialog-link {
    width: 100%;
    margin: auto;
    text-align: center;
  }
`

const DialogOverlay = styled.div`
  position: fixed;
  z-index: 99;
  top: -25%;
  left: 0;
  bottom: 0;
  right: 0;
  height: 125%;
  width: 100%;
  background: #000;
  display: none;
  opacity: 0.5;
  ${({ open }: StyledProps) => css`
    ${open &&
    css`
      display: block;
    `}
  `}
`

export default withRouter(ShortInternshipCorpContact)
